module.exports = __webpack_public_path__ + "img/animation_en.ebe2062.jpg";